import React from "react";

import {
    Space,
    Button,
    Modal,
    notification,
    Alert,
    Table as TableAntd,
    Upload,
    InputNumber,
    Progress,
    Card, Divider, Typography, Spin
} from "antd";
import {UploadOutlined} from "@ant-design/icons"
import {
    submitRefTableData,
    uploadFile,
    visualizeWithFilter,
    cancelFileUploadJob,
    insertNewRefTableData,
} from "../../api/api";
import JSZip from "jszip";
import moment from "moment";
import PropTypes from "prop-types";
import {DefaultProps, PaginatedLoad, RefTable, Validator} from "../RefTable";
import "../../styles/CustomsDutyRates.css"
import {unstable_batchedUpdates} from "react-dom";


export const FileEntry = (props) => {
    return <Upload customRequest={() => {
    }} accept={props.extension} multiple={false} showUploadList={false} onChange={props.onLoad}>
        <Button className={props.className} icon={<UploadOutlined/>}>{props.title}</Button>
    </Upload>
}

FileEntry.propTypes = {
    onLoad: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    fileId: PropTypes.string.isRequired,
    className: PropTypes.string,
    extension: PropTypes.string,
}
FileEntry.defaultProps = {
    className: "file-selector",
    extension: ".xlsx"
}

export const Fileset = (props) => {
    const [files, setFiles] = React.useState({})

    const onload = React.useCallback((key, file) => {
        const combined = {...files, [key]: file}
        setFiles(combined)
    }, [props, files])

    React.useEffect(()=>{
        if (!props.files.find(o => files[o.fileId] == null)) {
            const f = props.files.map(o=>({...o, file: files[o.fileId]}))
            props.zip(f).then(props.onReady)
            setFiles({})
        }
    }, [files, props])


    return <React.Fragment>
        <div className={"fileset"}>
            {props.files.map((o) => <div className={"upload-entry"}>
                <FileEntry className={props.className} extension={props.extension} title={`Click to Upload ${o.title}`} fileId={o.fileId} onLoad={(e) => onload(o.fileId, e)}/>
                {files[o.fileId] && <div className={"ant-tag ant-tag-red filename"}>{files[o.fileId].file.name}</div>}
            </div>)}
        </div>
    </React.Fragment>
}
Fileset.propTypes = {
    files: PropTypes.arrayOf(PropTypes.shape({
        fileId: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired
    })),
    zip: PropTypes.func,
    className: PropTypes.string,
    extension: PropTypes.string,
    onReady: PropTypes.func
}

Fileset.defaultProps = {
    zip: async (files) => {
        const zip = new JSZip();
        for (let {fileId, file} of files) {
            zip.file(fileId, file.file.originFileObj);
        }
        return new Promise(resolve => {
            zip.generateAsync({type: "blob", compression: "DEFLATE"}).then((content) => resolve({content, files}))
        })
    },
    files: [
        {fileId: "duties_import", title: "Duties Import File"},
        {fileId: "areas_and_regions", title: "Areas and Regions File"},
        {fileId: "country_exclusions", title: "Country Exclusions File"},
    ]
}

const ProgressContext = React.createContext();

export const ProgressView = (props) => {

    const [_v, setValue] = React.useState({})


    const init = React.useCallback(async () => {
        const {id, progress, response} = await props.fetch() || {};
        if (progress !== undefined && progress !== 100) {
            setValue({id, progress, response})
            setTimeout(init, props.pollInterval)
        } else {
            if(progress === 100)
                props.onSuccess(id, progress, response);
            setValue({response})
        }
    }, [props])

    React.useEffect(() => {
        init();
    }, [props])

    return <ProgressContext.Provider value={{value: _v, init}}>
        <div>
            {_v.progress !== undefined && <div className={"progress"}>
                <Progress percent={_v.progress}/>
                <Button disabled={_v.progress === 100} onClick={async () => {
                    await props.onCancel(_v.id);
                }} type="primary" danger>{_v.progress === 100 ? props.finalizingText : props.cancelText}</Button>
            </div>}
            {props.children}

        </div>
    </ProgressContext.Provider>
}


ProgressView.propTypes = {
    onCancel: PropTypes.func,
    fetch: PropTypes.func,
    pollInterval: PropTypes.number,
    cancelText: PropTypes.string,
    finalizingText: PropTypes.string,
}

ProgressView.defaultProps = {
    cancelText: "Cancel Job",
    finalizingText: "Finalizing ...",
    pollInterval: 5000,
    fetch: async () => {
        const {data: {rows: [first] = []}} = await visualizeWithFilter({
            tableName: "file_upload_job",
            conditions: [{key: "type", value: 'custom_duty_rate'}, {key: "status", value: 'pending'}]
        });
        return first
    },
    onCancel: async (id, data_type) => {
        await cancelFileUploadJob({id, data_type})
    },
    onSuccess: async (id, data_type)=>{
        await cancelFileUploadJob({id, data_type})
    }
}

export const UploadFileset = (props) => {
    const [open, setOpen] = React.useState(false)
    const [info, setInfo] = React.useState(undefined)
    const [err, setErr] = React.useState(undefined)

    return <React.Fragment>
        <Button style={{width: 160}} icon={<UploadOutlined/>} onClick={() => {
            setOpen(true)
        }}>Upload Files</Button>
        {open && <Modal
            centered
            closable={true}
            width={650}
            onCancel={() => {
                unstable_batchedUpdates(()=>{
                    setOpen(false)
                    setInfo(undefined)
                    setErr(undefined)
                })

            }}
            footer={null}
            title={`Custom Duty Rate File Upload`}
            visible={open}
        >
            <ProgressView onCancel={async (id)=> {cancelFileUploadJob(({id, 'data_type':props.dataType }))}}
                          fetch={async () => {
            const {data: {rows: [first] = []}} = await visualizeWithFilter({
            tableName: "file_upload_job",
            conditions: [{key: "type", value: props.dataType}, {key: "status", value: 'pending'}]
        });
            return first
        }}
                onSuccess={async (id, progress, response)=>{
                cancelFileUploadJob({id, 'data_type':props.dataType})
                setInfo({
                    message:"Custom Duty Rates uploaded successfully",
                    descTitle: `${response['noOfRowsUploaded']} record(s) out of  ${response['noOfRows']} records(s) uploaded, ${response['excludeRowCount']} records(s) excluded and 
                            ${response['skippedRows']} record(s) skipped for duplicate rows`,
                    type:"success",
                    showIcon: true
                })
            }}>
                <ProgressContext.Consumer>
                    {p => <Spin spinning={p?.value?.progress !== undefined && p?.value?.progress !== 100}>
                        <Fileset onReady={async ({content:file, files}) => {
                            const zipFile = new File([file], 'test.zip', {type: "zip"});
                            setInfo({
                                message: "Files uploading .....",
                                type:"info",
                                showIcon: true,
                                descTitle: "Uploading files ...",
                                desc: files.map(o=>`${o.title} : ${o.file.file.name}`)
                            })
                            const formData = new FormData();
                            formData.append('data_type', props.dataType);
                            formData.append('file', zipFile);
                            try {
                                const res = await uploadFile(formData)
                                if(res && res.status === 200){
                                    const {data:[first]} = res
                                    const {errorList, status, errorMsg = "Error in file Uploading!"} = first || {}
                                    if(status === 'error') {
                                        throw {message: errorMsg}
                                    }
                                    unstable_batchedUpdates(()=>{
                                        setErr(errorList)
                                        setInfo({
                                            message: "File upload job created...",
                                            type: "info",
                                            showIcon: true
                                        })
                                    })
                                }
                                else {
                                    throw {message: 'Error in file uploading'}
                                }

                            }catch (e){
                                setInfo({
                                    message: e.message,
                                    type: "error",
                                    showIcon: true
                                })
                            }
                            p?.init()
                        }
                        }/>
                    </Spin>}
                </ProgressContext.Consumer>
                {info  && <Alert {...info} description={<React.Fragment>
                    {info.descTitle && <Typography.Text>{info.descTitle}</Typography.Text>}
                    {info.desc && <ol>{info.desc.map(o=><li>{o}</li>)}</ol>}
                </React.Fragment>}/>}
                {err && <TableAntd dataSource={err} size={'small'}>
                    <TableAntd.Column title={"Error Type"} dataIndex={"error"}/>
                    <TableAntd.Column title={"Field"} dataIndex={"column"}/>
                    <TableAntd.Column title={"No. of Occurrences"} dataIndex={"occurrence"}/>
                </TableAntd>}

            </ProgressView>

        </Modal>}
    </React.Fragment>
}

export const StandardRate = (props) => {

    const [edit, setEdit] = React.useState(false);
    const [value, setValue] = React.useState(props.value);
    const [id, setId] = React.useState()


    React.useEffect(() => {
        visualizeWithFilter({
            tableName: "customs_duty_standard",
            conditions: [{key: "name", value: props.name}]
        }).then(({data: {rows: [first]}}) => {
            setValue(first.rate || 0)
            setId(first.id)
        });
    }, [edit])

    return <Card bodyStyle={{paddingBottom: 10, paddingTop: 10}}>
        <Space>
            <Typography.Text>Standard Customs Duty Rate :</Typography.Text>
            <InputNumber value={value} onChange={(e) => setValue(e)} disabled={!edit}/>
            {!edit && <Button onClick={() => setEdit(true)}>Edit</Button>}
            {edit && <Button onClick={async () => {
                const {data: {statusCode}} = await submitRefTableData({
                    id: id,
                    name: props.name,
                    rate: value
                }, 'customs_duty_standard');
                if (statusCode === 200) {
                    notification.success({message: `Standard Customs Duty Rate Updated`});
                }
                setEdit(false)
            }}>Save</Button>}
            {edit && <Button onClick={() => setEdit(false)}>Cancel</Button>}
        </Space>
    </Card>
}


export const CustomsDutyRates = (props) => <RefTable {...props}/>;

CustomsDutyRates.defaultProps = {
    ...DefaultProps,
    title: "Customs Duty Rates",
    tableSchema: "country_customs_duty_rate",
    tableName: "country_customs_duty_rate",
    filterSchema: "country_customs_duty_rate_filter",
    edit: true,
    fetch: PaginatedLoad,
    tfootHeight: 50,
    headerOrder: ["customActionElements", "add", "actions"],
    addNewRecordSchema: "country_customs_duty_rate_form",
    customRenderer: {
        end_date: (value) => value ? moment(value).format("YYYY-MM-DD") : ""
    },
    enrichForm: (cols) => cols.map(o => o.name === "hs6p_code" ? {
        ...o,
        format: {regex: /\D/g, format: ''},
        mask: {regex: /^(\d{4})(\d{1,2})/g, format: '$1 $2 '}
    } : o),
    enrichColumns: (cols) => cols.map(o => o.name === "measure_type_code" ? {
        ...o,
        minWidth: 150
    } : o),
    validator: {
        customs_duty: new Validator("customs_duty", async (value) => {
            if (value < 0)
                return Promise.reject("Duty cannot be negative")
        }),
        end_date: new Validator("end_date", async (value) => {
            if (moment().diff(moment(value)) > 0)
                return Promise.reject("End date cannot be less than the current date")
        }),
    },
    customActionElements: [
        <StandardRate value={0} name={"standard_rate"} key={"standard"}/>,
        <Divider type={"vertical"} key={"sep"}/>,
        <UploadFileset key={"upload"} dataType={"custom_duty_rate"}/>
    ],
    insertData: async (tableName, data)=>{
        data['hs6p_code'] = data['hs6p_code'].replace(/\D/g, '')
       return await insertNewRefTableData(data, 'country_customs_duty_rate')
    }
}
